import Mock from "../screens/mock";
import { routes as adminRoutes } from "../areas/admin";
import { routes as analyticsRoutes } from "../areas/analytics";
import { routes as reportingRoutes } from "../areas/reporting";

const baseRoutes = [

  {
    path: "/mock",
    component: <Mock />,
    exact: null,
    label: null,
  },
];

export const ROUTES = [
  ...baseRoutes,
  ...adminRoutes,
  ...analyticsRoutes,
  ...reportingRoutes,
];
